import React from "react";

const InteractiveList = ({
  chatbotOption,
  updateInfo,
  errors
}) => {
  const handleInputChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    updateInfo(name, value);
  };

  return (
    <>
      <div className="col-md-12 mt-20">
        <div className="figma-field mb-0">
          <label>Texto del botón de mostrar lista</label>
          <span className="ml-10 error-msg fz-12">{errors.button_title}</span>
          <input
            value={chatbotOption.button_title}
            onChange={handleInputChange}
            className="input"
            name="button_title"
            maxLength={20}
          />
        </div>
      </div>

      <div className="col-md-12 mt-20">
        <div className="figma-field mb-0">
          <label>Titulo de la sección de opciones de respuesta</label>
          <span className="ml-10 error-msg fz-12">{errors.selection_title}</span>
          <input
            value={chatbotOption.selection_title}
            onChange={handleInputChange}
            className="input"
            name="selection_title"
            maxLength={24}
          />
        </div>
      </div>
    </>
  );
};

export default InteractiveList;
